import { z } from "zod";
import { AwsAuthSchema, BearerAuthSchema, HttpAuthSchema, NoneAuthSchema, ProxyAuthSchema } from "../types";

export const FreeV1Schema = z.object({
    plan: z.literal("free"),
    version: z.literal("free@1"),
    lastUpdated: z.string().datetime(),
    private: z.object({
        origin: z.string().optional(),
        security: z.object({
            permittedUrls: z.array(z.string())
        }).optional(),
        authentication: z.union([
            NoneAuthSchema,
            BearerAuthSchema,
            HttpAuthSchema,
            AwsAuthSchema,
            ProxyAuthSchema,
        ]),
    }),
    public: z.object({
        publication: z.object({
            key: z.string().optional()
        }).optional(),
    })
});

export type FreeV1 = z.infer<typeof FreeV1Schema>;